import React from "react";
// import Slider from "@mui/material";
import axios from "axios";
import style from "../styles/AllProducts.module.css";
import HomeIcon from "@mui/icons-material/Home";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import PCard from "./PCard";
import Loder from "./Loder";

//  create pagination
function createArrayOfSize(n) {
  return new Array(n).fill(0);
}

function Pagination({ totalPages, currentPage, handlePageChange }) {
  let pages = createArrayOfSize(totalPages).map((a, i) => {
    return (
      <button
        style={{
          height: "20px",
          margin: "5px",
          backgroundColor: currentPage == i + 1 ? "green" : "#0f287b",
          color: "white",
          border: "none",
          borderRadius: "5px",
          padding: "5p 10px",
        }}
        disabled={currentPage === i + 1}
        key={i}
        onClick={() => handlePageChange(i + 1)}
      >
        {i + 1}
      </button>
    );
  });
  return <div>{pages}</div>;
}

function MobileandTablet() {
  const navigate = useNavigate();
  // page , limit and countof all product
  const [page, setpage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [allPoduct, setAllProduct] = useState(0);
  const [totalpages, setTotalPages] = useState(0);

  // setTotalPages(Tpage);
  //  min max values of range slider
  const [minval, setmin] = useState(0);
  const [maxval, setMax] = useState(500);

  // data  , loding , error
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [order, setorder] = useState("");
  const [Error, SetError] = useState(false);

  // sort high to low
  const HighToLow = () => {
    setpage(1);
    setorder("desc");
  };
  // sort low to high
  const LowToHigh = () => {
    setpage(1);
    setorder("asc");
  };

  const getData = (params = {}) => {
    return axios
      .get(`https://infinite-digitals.onrender.com/mobilesandtablets`, {
        params: {
          _page: params.page,
          _limit: params.limit,
          _sort: params.sort,
          _order: params.order,
        },
      })
      .then((res) => {
        const totalcount = res.headers.get("x-total-count");
        return {
          data: res.data,
          totalnumberofpages: totalcount,
        };
      });
  };

  const fetchAndUpadateData = async () => {
    try {
      setLoading(true);
      const data = await getData({
        page: page,
        limit: limit,
        sort: "price",
        order: order,
      });
      setData(data.data);
      setAllProduct(data.totalnumberofpages);
      const tpage = data.totalnumberofpages / limit;
      setTotalPages(tpage);
      setLoading(false);
    } catch (error) {
      SetError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAndUpadateData();
    const Tpage = Math.ceil(allPoduct / limit);
    setTotalPages(Tpage);
  }, [page, order]);
  // input bax handling max value
  const handleChange = (e) => {
    setMax(e.target.value);
  };

  // inptu box handling min value
  const handleChangeMin = (e) => {
    setmin(e.target.value);
  };
  // paination
  const handlePageChange = (pageNumber) => {
    setpage(pageNumber);
  };

  console.log(allPoduct);

  if (loading) {
    return <Loder />;
  }
  return (
    <>
      <div className={style.empty_mobileandtablet}></div>

      <div className={style.AllproductCont}>
        <div className={style.top_home}>
          <p>
            <Link to="/">
              <HomeIcon className={style.top_home_icon} />
            </Link>
            <ChevronRightIcon className={style.top_home_icon} /> Brand{" "}
            <ChevronRightIcon className={style.top_home_icon} /> Product Listing
          </p>
        </div>

        <div className={style.countainer}>
          <div className={style.all_filters}>
            <div className={style.filter_heading}>
              <p>FILTERS</p>
            </div>
            <div>
              <p>Price</p>
              <input
                className={style.range_slider}
                type="range"
                stap="10"
                min="100"
                max="100000"
                value={maxval}
                onChange={handleChange}
              />
              <div className={style.minandmax_val}>
                <p>{`₹${minval}`}</p>
                <p>{`₹${maxval}`}</p>
              </div>

              <div className={style.min_max_range}>
                <input value={minval} onChange={handleChangeMin} type="text" />
                <input value={maxval} onChange={handleChange} type="text" />
                <button className={style.GO_BTN}>GO</button>
              </div>
            </div>
            <div>
              <p className={style.filter_name_cont}>Availablity</p>
              <div className={style.filter_name_with_checkbox}>
                <input type="checkbox" />
                <p>Exclude out of stack</p>
              </div>
            </div>
          </div>
          <div className={style.Allproduct_show}>
            <div className={style.allp_top}>
              <div>
                <h2>BRAND</h2>
                <p>{`Showing ${limit} products of ${allPoduct}`}</p>
              </div>
              <div>
                <div className={style.pricefilter_low_high_BTNS}>
                  <p style={{ fontWeight: "500" }}>Sort By:</p>
                  <button className={style.relevence_BTN}>Relevence</button>
                  <button onClick={LowToHigh} className={style.price_low_high}>
                    Price(Low-High)
                  </button>
                  <button onClick={HighToLow} className={style.price_low_high}>
                    Price(High-Low)
                  </button>
                </div>
              </div>
            </div>
            {/* Sho all products here import Product card here */}
            <div className={style.product__added}>
              {Data?.map((ele, i) => {
                return (
                  <div key={i + 1}>
                    <Link
                      style={{ textDecoration: "none", color: "inherit" }}
                      to={`/computers/${ele.id}`}
                    >
                      <PCard {...ele} />
                    </Link>
                  </div>
                );
              })}
            </div>
            <div className={style.pegi}>
              <Pagination
                totalPages={totalpages}
                currentPage={page}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MobileandTablet;
